import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import ImageButtonList from '../common/imageButtonList';
import ImageText from '../common/imageText';
import NavigationBar from '../common/navigationBar';
import fallPrecautionElements from './images/fall_precaution/elements_fallrisk.png';
import exitHighlight from './images/fall_precaution/Exit_HL.png';
import exitUnhighlight from './images/fall_precaution/Exit_UH.png';
import viewNowHighlight from './images/fall_precaution/ViewVideosNow_HL.png';
import viewNowUnhighlight from './images/fall_precaution/ViewVideosNow_UH.png';

class FallPrecaution extends Component {
  /**************
   * Properties *
   **************/
  state = {
    buttons: [
      {
        id: 'view-now',
        to: '/assigned_education/roles',
        highlight: viewNowHighlight,
        unhighlight: viewNowUnhighlight,
        alt: 'View Now'
      },
      {
        id: 'exit',
        to: '/main_menu',
        highlight: exitHighlight,
        unhighlight: exitUnhighlight,
        alt: 'Exit'
      }
    ],
    navigationBar: {
      mainMenu: false,
      back: false,
      backRoute: '/main_menu'
    }
  };

  /**
   * Renders the component.
   *
   * @public
   *
   * @returns { React.Component }  The rendered view of the component.
   *
   */
  render() {
    return (
      <div className="service-1101-fall-precaution">
        <ImageText src={fallPrecautionElements} top="-28.6" left="-5.2" unit="rem" />
        <ImageButtonList imageButtons={this.state.buttons} />
        <NavigationBar {...this.state.navigationBar} />
      </div>
    );
  }
}

export default withRouter(FallPrecaution);
